import React, { useId } from 'react';

import { Separator } from '../styled';
import TextPrompt from '../text-prompt';
import {
	FormControlContainer,
	InputLabelComponent,
	InputPrefix,
	InputWithPrefixWrapper,
	TextInput,
	TextInputWithPrefix,
} from './styled';

interface IInput extends Omit<React.ComponentPropsWithoutRef<'input'>, 'prefix'> {
	label?: string;
	error?: string | undefined;
	isvalid?: boolean;
	customwidth?: string | number;
	inputPrefix?: React.ReactNode;
}

// eslint-disable-next-line react/display-name
export const TypeInput = React.forwardRef(({ label, error, isvalid, inputPrefix, ...props }: IInput, ref) => {
	const generatedId = useId();
	const inputId = props.id || props.name || generatedId;
	const errorId = error ? `${inputId}-error` : undefined;

	return (
		<FormControlContainer>
			{label && (
				<InputLabelComponent htmlFor={inputId}>
					{label}
					{props.required && (
						<span
							aria-hidden='true'
							style={{ color: 'var(--color-error)', marginLeft: '4px' }}
						>
							*
						</span>
					)}
				</InputLabelComponent>
			)}
			{inputPrefix ? (
				<InputWithPrefixWrapper
					iserror={error}
					isvalid={isvalid}
				>
					<InputPrefix aria-hidden='true'>{inputPrefix}</InputPrefix>
					<TextInputWithPrefix
						{...props}
						id={inputId}
						ref={ref as React.LegacyRef<HTMLInputElement> | undefined}
						aria-invalid={!!error}
						aria-describedby={errorId}
						aria-required={props.required}
					/>
				</InputWithPrefixWrapper>
			) : (
				<TextInput
					{...props}
					id={inputId}
					iserror={error}
					isvalid={isvalid}
					ref={ref as React.LegacyRef<HTMLInputElement> | undefined}
					aria-invalid={!!error}
					aria-describedby={errorId}
					aria-required={props.required}
				/>
			)}
			{!!error && (
				<>
					<Separator />
					<TextPrompt
						prompt={error}
						status={false}
						id={errorId}
						role='alert'
					/>
				</>
			)}
		</FormControlContainer>
	);
});
